import { render, staticRenderFns } from "./setSalaryStandard.vue?vue&type=template&id=48808a44&scoped=true"
import script from "./setSalaryStandard.vue?vue&type=script&lang=js"
export * from "./setSalaryStandard.vue?vue&type=script&lang=js"
import style0 from "./setSalaryStandard.vue?vue&type=style&index=0&id=48808a44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48808a44",
  null
  
)

export default component.exports